/* ============================================================
   BURIED IN WORK — V2 product page behaviour
   Replaces the sticky-bar half of biw-ck-look-v1.js. The "look inside"
   filmstrip in that file is good and is left alone.

   Two defects in V1 this fixes:

   1. PRICE. V1 resolved the price node ONCE at init:
        var priceEl = document.querySelector('.price__container ...')
      Dawn re-renders the whole price container on a variant change, so that
      reference goes stale (detached) and syncPrice() kept reading $199 from an
      orphaned node while the page showed $349. Fix: resolve on every read.

   2. THE BUTTON. V1's bar button was labelled "Add to cart" and only scrolled.
      That was a deliberate choice, documented in V1: proxy-submitting risked
      bypassing the personalisation app's validation, and the printed name is
      load-bearing for fulfilment.
      V2 keeps that protection but honours the label by CLICKING THE REAL
      BUTTON rather than submitting the form. Every handler any app has bound
      to that button runs exactly as if the shopper pressed it themselves, the
      add-on interceptor still sees the submit, and native validation still
      focuses (and scrolls to) an invalid field.
   ============================================================ */
(function () {
  'use strict';

  function buyForm() {
    return document.querySelector('product-form form[action*="/cart/add"][data-type="add-to-cart-form"]')
      || document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]')
      || document.querySelector('product-form form[action*="/cart/add"]');
  }

  function realButton() {
    var f = buyForm();
    return f ? f.querySelector('[name="add"]') : null;
  }

  /* Read the live price every time. Never cache the node. */
  function currentPrice() {
    // V3 removed Dawn's price block from the kit templates, so .price__container
    // does not exist there and the old last resort, a bare document
    // .querySelector('.price'), matched whatever came first in the DOM: an
    // add-on price, or an item sitting in the cart drawer. The $449 Expanded
    // page read "Two Adults - $29.99" with anything in the drawer.
    //
    // The price now comes from the SELECTED option card, and every lookup is
    // scoped to the product form so nothing outside it can ever be read.
    var scope = document.querySelector('.product__info-container')
      || document.querySelector('product-info')
      || document;

    var checked = scope.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (checked && checked.id) {
      var lab = scope.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(checked.id) : checked.id) + '"]');
      var card = lab && lab.querySelector('.v2-optcard__price');
      if (card) return (card.textContent || '').replace(/\s+/g, ' ').trim();
    }
    // single-variant kit pages still print one card
    var only = scope.querySelectorAll('.v2-optcard__price');
    if (only.length === 1) return (only[0].textContent || '').replace(/\s+/g, ' ').trim();

    var el = scope.querySelector('.price__container .price-item--sale:not(.hidden)')
      || scope.querySelector('.price__container .price-item--regular')
      || scope.querySelector('.price__container .price-item')
      || scope.querySelector('.price__container');
    if (!el) return '';
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* The chosen option, so the price in the bar is never ambiguous. */
  function currentVariantLabel() {
    var picked = [];
    document.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function (r) {
      if (r.value) picked.push(r.value.trim());
    });
    if (!picked.length) {
      document.querySelectorAll('variant-selects select').forEach(function (s) {
        if (s.value) picked.push(s.value.trim());
      });
    }
    return picked.join(' · ');
  }

  function initBar() {
    var bar = document.querySelector('[data-v2bar]');
    var form = buyForm();
    if (!bar || !form) return;

    document.body.classList.add('v2-has-stickybar');

    var priceOut = bar.querySelector('[data-v2bar-price]');
    var btn = bar.querySelector('.biwbar__btn');

    /* Variant line, injected once if the theme markup predates it. */
    var variantOut = bar.querySelector('[data-v2bar-variant]');
    if (!variantOut) {
      var left = bar.querySelector('.biwbar__l');
      if (left) {
        variantOut = document.createElement('span');
        variantOut.className = 'biwbar__v';
        variantOut.setAttribute('data-v2bar-variant', '');
        var titleEl = left.querySelector('.biwbar__t');
        if (titleEl && titleEl.nextSibling) left.insertBefore(variantOut, titleEl.nextSibling);
        else left.appendChild(variantOut);
      }
    }

    function sync() {
      var p = currentPrice();
      if (priceOut && p && priceOut.textContent.trim() !== p) priceOut.textContent = p;

      var v = currentVariantLabel();
      if (variantOut && variantOut.textContent.trim() !== v) variantOut.textContent = v;

      /* Mirror the real button's availability so the bar can never offer
         something the form itself refuses. */
      var rb = realButton();
      if (btn && rb) {
        /* Dawn disables the real button for a few hundred ms while it
           re-renders the section. Debounce so a genuinely available product
           never flickers to a disabled state in the bar. */
        var off = !!rb.disabled;
        if (off) {
          if (!btn.dataset.offSince) btn.dataset.offSince = String(Date.now());
          if (Date.now() - Number(btn.dataset.offSince) > 1200 && !btn.disabled) btn.disabled = true;
        } else {
          delete btn.dataset.offSince;
          if (btn.disabled) btn.disabled = false;
        }
      }
    }

    function shouldShow() {
      var f = buyForm();
      if (!f) return false;
      var r = f.getBoundingClientRect();
      var pastForm = r.bottom < 0;
      var nearEnd = (window.innerHeight + window.scrollY) > (document.documentElement.scrollHeight - 220);
      return pastForm && !nearEnd;
    }

    var shown = null;
    function update() {
      var want = shouldShow();
      if (want !== shown) {
        shown = want;
        bar.setAttribute('data-show', want ? 'true' : 'false');
        bar.setAttribute('aria-hidden', want ? 'false' : 'true');
        /* Keep it out of the tab order while hidden. */
        if (btn) btn.tabIndex = want ? 0 : -1;
      }
      sync();
    }

    /* Click the REAL button. Not a proxy submit — this preserves every
       validation handler bound to it by the personalisation app. */
    if (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var rb = realButton();
        if (!rb || rb.disabled) return;
        rb.click();
        /* If something blocked the add (invalid or unfilled required field),
           the browser focuses it but may leave it off-screen behind the
           sticky header. Nudge it into view on the next frame. */
        window.requestAnimationFrame(function () {
          var bad = document.querySelector(':invalid, [aria-invalid="true"]');
          if (bad && typeof bad.scrollIntoView === 'function') {
            bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      });
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    /* Dawn republishes the section on variant change; observe rather than poll. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) {
        setTimeout(sync, 60);
        setTimeout(sync, 350);
        setTimeout(sync, 900);
      }
    });
    if (window.MutationObserver) {
      var host = document.querySelector('.product__info-container') || document.body;
      new MutationObserver(function () { sync(); }).observe(host, { childList: true, subtree: true });
    }
    setInterval(update, 900);
    update();
  }

  /* ---------- variant option cards ------------------------------------
     Deliberately NOT done here.

     The first attempt rewrote Dawn's <label> contents from JS. Dawn
     re-renders the whole variant-selects element from the server on every
     variant change, so the enhancement survived exactly one click and then
     vanished — and while the section was mid-re-render the real Add to cart
     button was briefly disabled, which the sticky bar faithfully mirrored as
     "Unavailable". Caught by rendering it, not by reading the code.

     The price and the legend are now server-rendered in
     snippets/product-variant-options.liquid and product-variant-picker.liquid,
     so they come back correct with every re-render. The card styling keys off
     the .v2-optcard class in CSS. No JS involved.
     -------------------------------------------------------------------- */

  function boot() { initBar(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ---------- Live cover preview ----------
   Reads the personalization inputs the option script already owns and mirrors
   them onto the cover band. It never writes to the form. Adult 2's band follows
   the visibility of Adult 2's row, which the variant picker controls. */
(function () {
  'use strict';
  var root = null, in1 = null, in2 = null, fig2 = null, name1 = null, name2 = null;
  var EMPTY = 'Your name, as it will print';
  function skipFor(input) {
    var row = input.closest('[data-biwpers-row]') || input.parentElement;
    return row ? row.querySelector('.biwpers__skip input, input[type="checkbox"]') : null;
  }
  function paint(input, span) {
    if (!input || !span) return;
    var skip = skipFor(input);
    var v = (input.value || '').replace(/\s+/g, ' ').trim();
    span.classList.remove('is-empty', 'is-skipped');
    if (skip && skip.checked) { span.textContent = 'Not personalized'; span.classList.add('is-skipped'); return; }
    if (!v) { span.textContent = EMPTY; span.classList.add('is-empty'); return; }
    span.textContent = v;
  }
  function sync() {
    if (!root) return;
    paint(in1, name1);
    if (in2 && fig2) {
      var row2 = in2.closest('[data-biwpers-row]');
      var shown = row2 ? !row2.hidden && row2.getBoundingClientRect().height > 0 : in2.getBoundingClientRect().height > 0;
      fig2.hidden = !shown;
      if (shown) paint(in2, name2);
    }
  }
  function boot() {
    root = document.querySelector('[data-v2cover]');
    if (!root || root.dataset.v2wired) return;
    root.dataset.v2wired = '1';
    in1 = document.getElementById('biwpers-1');
    in2 = document.getElementById('biwpers-2');
    fig2 = root.querySelector('[data-v2cover-fig="2"]');
    name1 = root.querySelector('[data-v2cover-name="1"]');
    name2 = root.querySelector('[data-v2cover-name="2"]');
    root.hidden = false;
    document.addEventListener('input', sync, true);
    document.addEventListener('change', sync, true);
    setInterval(sync, 500);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
